import { timeParse } from 'd3'

const cashGenerationChartData = [
    {
        "dateString": "2010-12-31",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.25480584",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2011-06-30",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.221478364",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2011-12-31",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "-0.153481238",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2012-06-30",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.065140069",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2012-12-31",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.359097822",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2013-06-30",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.310692347",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2013-12-31",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.249351442",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2014-06-30",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.266269227",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2014-12-31",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.195525122",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2015-06-30",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.179996106",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2015-12-31",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.093275857",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2016-06-30",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.049092781",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2016-12-31",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "-0.154659412",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2017-06-30",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "-0.154934152",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2017-12-31",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.250205844",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2018-06-30",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.397289113",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2018-12-31",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.159173933",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2019-06-30",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "0.163848465",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2019-12-31",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "-0.005969128",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    },
    {
        "dateString": "2020-06-30",
        "earnings_cashflow_deviation": "",
        "earnings_cashflow_h_deviation": "-0.349344498",
        "chart_name": "Cash Generation (‘Excess Operating Cashflow’ as a % of Sales)",
        "chart_number": "8"
    }
]

const parseDate = timeParse('%Y-%m-%d')

export default cashGenerationChartData.map(d => {
  d['date'] = parseDate(d['dateString'])
  return d
})
